import React from 'react';
import First from './Sections/First';
import Second from './Sections/Second';

const AboutCompany = () => {
    return (
        <main>
            <First />
            <Second />
        </main>
    );
};

export default AboutCompany;